import { render, staticRenderFns } from "./TrainingSideNavigation.vue?vue&type=template&id=1f468ab6&scoped=true&"
import script from "./TrainingSideNavigation.vue?vue&type=script&lang=js&"
export * from "./TrainingSideNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TrainingSideNavigation.vue?vue&type=style&index=0&id=1f468ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f468ab6",
  null
  
)

export default component.exports